export function isLocalStorageUsable(): boolean {
    try {
        if (typeof localStorage === 'undefined') return false;
        const k = '__ls_test__';
        localStorage.setItem(k, '1');
        localStorage.removeItem(k);
        return true;
    } catch {
        return false;
    }
}

export function safeGetLocalStorage(key: string): string | null {
    try {
        if (typeof localStorage === 'undefined') return null;
        const v = localStorage.getItem(key);
        if (!v || v === 'null' || v === 'undefined') return null;
        return v;
    } catch {
        return null;
    }
}

export function safeSetLocalStorage(key: string, value: string): boolean {
    try {
        if (typeof localStorage === 'undefined') return false;
        localStorage.setItem(key, value);
        return true;
    } catch {
        return false;
    }
}